module.exports = __webpack_public_path__ + "static/media/deck-4-wild.4f3b15ec.png";